
import { ref, toRaw, computed } from 'vue'
import { setNoEmptyForm } from '@/util/common'
export default (bindStatus: { value: any }) => {
  const searchForm = ref({})
  const filterData = computed(() => {
    return {
      ...setNoEmptyForm({
        ...toRaw(searchForm.value),
        bindStatus: bindStatus.value
      })
    }
  })
  return {
    searchForm,
    filterData
  }
}
